import React, { useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import { debounce } from "../../utils/Debounce";

// Shared across both tabs and both drill levels. Which of the two search
// boxes is meaningful depends on what's currently on screen — the inactive
// one is greyed out rather than hidden, so the bar doesn't jump around.
function FilterBar({
  onSiteSearchChange,
  siteSearchDisabled,
  onCustSearchChange,
  custSearchDisabled,
  dateRange,
  onDateRangeChange,
  onAddCustomColumn,
}) {
  const [customTerm, setCustomTerm] = useState("");
  const handleSiteSearchChange = debounce((val) => onSiteSearchChange(val), 500);
  const handleCustSearchChange = debounce((val) => onCustSearchChange(val), 500);

  const submitCustomTerm = () => {
    const term = customTerm.trim();
    if (!term) return;
    onAddCustomColumn(term);
    setCustomTerm("");
  };

  return (
    <div className="flex flex-wrap items-end gap-4 mb-4 bg-white border border-gray-200 rounded-lg p-4">
      <div className="max-w-xs">
        <label className="mb-1 text-sm font-semibold text-gray-600 block">Search Site ID</label>
        <input
          type="text"
          disabled={siteSearchDisabled}
          onChange={(e) => handleSiteSearchChange(e.target.value)}
          placeholder="Filter by site_id..."
          className={`border rounded px-3 py-2 w-full text-sm ${
            siteSearchDisabled ? "bg-gray-100 text-gray-400 cursor-not-allowed" : ""
          }`}
        />
      </div>
      <div className="max-w-xs">
        <label className="mb-1 text-sm font-semibold text-gray-600 block">Search Cust ID</label>
        <input
          type="text"
          disabled={custSearchDisabled}
          onChange={(e) => handleCustSearchChange(e.target.value)}
          placeholder="Filter by cust_id..."
          className={`border rounded px-3 py-2 w-full text-sm ${
            custSearchDisabled ? "bg-gray-100 text-gray-400 cursor-not-allowed" : ""
          }`}
        />
      </div>
      <div className="min-w-[260px]">
        <label className="mb-1 text-sm font-semibold text-gray-600 block">Date Range</label>
        <div className="border rounded-lg border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500">
          <Datepicker
            value={dateRange}
            onChange={onDateRangeChange}
            primaryColor="cyan"
            showShortcuts
            asSingle={false}
            placeholder="All time"
          />
        </div>
      </div>
      <div className="max-w-xs">
        <label className="mb-1 text-sm font-semibold text-gray-600 block">Search Alt/Title/Text</label>
        <div className="flex gap-2">
          <input
            type="text"
            value={customTerm}
            onChange={(e) => setCustomTerm(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submitCustomTerm()}
            placeholder="Search alt/title/text..."
            className="border rounded px-3 py-2 w-full text-sm"
          />
          <button
            type="button"
            disabled={!customTerm.trim()}
            onClick={submitCustomTerm}
            className={`px-3 py-2 rounded text-sm font-semibold whitespace-nowrap ${
              customTerm.trim() ? "bg-sky-600 text-white hover:bg-sky-700" : "bg-gray-100 text-gray-400 cursor-not-allowed"
            }`}
          >
            Add Column
          </button>
        </div>
      </div>
    </div>
  );
}

export default FilterBar;
